<template>
  <div class="signin">
    <b-container>
      <!-- <b-row align-h="center">
        <b-col cols="5" class="mb-3 mt-5 text-center">
          <h4> </h4>
        </b-col>
      </b-row>-->
      <b-row align-h="center">
        <b-col md="6">
          <b-card class="bs pt-2 mt-5">
            <b-card-text class="text-center" v-if="showbah && showAppLaunch()">
               <b-button @click="doBAH" variant="primary">
                Become a Host
               </b-button>
            </b-card-text>
            <b-card-text class="text-center" v-if="userAccount.logo">
               <img style="max-width:100%" :src="userAccount.logo">
               </img>
            </b-card-text>
            <b-card-text class="pb-2">
               <b-form-group v-if="userAccount.go">
                 Changing to account
               </b-form-group>
               <b-form-group class="text-center">
                    <b-form-input
                      id="input-account"
                      v-model="userAccount.q"
                      :state="userAccount.state"
                      placeholder="Domain or Account"
                      aria-describedby="input-account-feedback"
                      style="background-size:0; text-align:center;"
                      trim>
                    </b-form-input>
                    <b-form-invalid-feedback id="input-account-feedback">
                      Enter a valid domain or account name
                    </b-form-invalid-feedback>
               </b-form-group>
               <b-form-group v-if="false && userAccount.go">
                    <b-button @click="goAccount" variant="success">
                      Switch
                    </b-button>
               </b-form-group>
               <b-form-group v-if="!userAccount.go">
               <span v-for="(past) in userAccount.pastlist">
                 <b-button style="padding:0 0.3rem" @click="selectPast(past.dom)"
                   :variant=past.var>
                   {{ past.name }}
                 </b-button>
               </span>
               </b-form-group>
            </b-card-text>
            <b-card-text class="text-center" v-if="!userAccount.go">
              <h5>Sign In Using Social Login </h5>
            </b-card-text>
            <b-card-text v-if="!userAccount.go">
              <div class="tcon">
                <div class="tpart"
                  v-if="userAccount.showgg">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:white; width:56px; height:56px;"
                    @click="ggSignIn"
                   >
                    <a>
                      <i class="google-icon__icon___1aU-8">
                        <svg width="16" height="16" viewBox="2 2 18 18">
                          <g
                            id="Google-Button"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="9-PATCH"
                              transform="translate(-608.000000, -160.000000)"
                            />
                            <g
                              id="btn_google_light_normal"
                              transform="translate(-1.000000, -1.000000)"
                            >
                              <g
                                id="button"
                                transform="translate(4.000000, 4.000000)"
                                filter="url(#filter-1)"
                              >
                                <g id="button-bg">
                                  <use fill="#FFFFFF" fill-rule="evenodd" />
                                  <use fill="none" />
                                  <use fill="none" />
                                  <use fill="none" />
                                </g>
                              </g>
                              <g
                                id="logo_googleg_48dp"
                                transform="translate(3, 3)"
                              >
                                <path
                                  d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"
                                  id="Shape"
                                  fill="#4285F4"
                                  Googl="true"
                                />
                                <path
                                  d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"
                                  id="Shape"
                                  fill="#34A853"
                                />
                                <path
                                  d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"
                                  id="Shape"
                                  fill="#FBBC05"
                                />
                                <path
                                  d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"
                                  id="Shape"
                                  fill="#EA4335"
                                />
                                <path
                                  d="M0,0 L18,0 L18,18 L0,18 L0,0 Z"
                                  id="Shape"
                                />
                              </g>
                              <g id="handles_square" />
                            </g>
                          </g>
                        </svg>
                      </i>
                    </a>
                  </b-button>
                </div>
                <div class="tpart"
                  v-if="userAccount.showfb">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:#3b5998; width:56px; height:56px;"
                    @click="fbSignIn"
                  >
                    <a class="text-light" style="font-size:24px;">
                      <i class="typcn typcn-social-facebook"></i>&nbsp;&nbsp;
                    </a>
                  </b-button>
                </div>
                <div class="tpart"
                  v-if="userAccount.showapl">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:white; padding:0; width:56px;"
                    @click="appleSignIn"
                  >
                    <img src="../../public/images/aplbl.svg"> </img>
                  </b-button>
                </div>
                <div class="tpart"
                  v-if="userAccount.showoutl">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:white; padding:0; width:56px;  height:56px;"
                    @click="outlookSignIn"
                  >
                    <img src="../../public/images/outlook.svg"> </img>
                  </b-button>
                </div>
              </div>              
            </b-card-text>
            <b-card-text class="text-center pt-2" v-if="!userAccount.go">
              <h5>Or, Vuemix Credentials </h5>
            </b-card-text>
            <b-card-text v-if="!userAccount.go">
              <b-form v-if="userAccount.showvx" v-on:submit.prevent="submitForm">
                <b-form-group class="pt-1">
                   <b-form-input
                    id="input-email"
                    type="email"
                    v-model="userForm.email"
                    required
                    placeholder="Enter email"
                  ></b-form-input>
                </b-form-group>
                <b-form-group class="pb-2">
                  <b-form-input
                    id="input-password"
                    type="password"
                    v-model="userForm.password"
                    required
                    placeholder="Enter password"
                  ></b-form-input>
                  <b-form-text>
                    <b-button block variant="primary mt-4" type="submit"
                      >Sign In</b-button
                    >
                  </b-form-text>
                </b-form-group>
              </b-form>
            </b-card-text>

            <b-card-text class="text-center pt-2"
              v-if="userAccount.showvx">
              <h5>Or, as a Guest </h5>
            </b-card-text>
            <b-card-text v-if="userAccount.showvx">
               <b-form-text>
                 <b-button block variant="primary mt-4"
                   @click="goGuest"
                   >
                   Guest
                 </b-button>
               </b-form-text>
            </b-card-text>

            <b-card-text v-if="!userAccount.go">
              <b-form v-if="userAccount.showvx">
                <b-form-group class="pt-1">
                  <b-form-text class="text-center">
                    <span v-if="userAccount.showreg">
                      <br/> New users can
                      <b-button pill size="sm" style="line-height:1.2;padding:1px 4px;" variant="outline-primary" @click="$parent.goRegister()" >
                        Register
                      </b-button>
                      here.
                    </span>
                  </b-form-text>
                  <b-form-text class="text-center">
                    <span v-if="userAccount.showvx">
                      Forgot your password
                      <b-button pill size="sm" style="line-height:1.2;padding:1px 4px" variant="outline-danger" @click="goPReset()">
                        Reset
                      </b-button>
                      here.
                    </span>
                  </b-form-text>
                  <b-form-text class="text-center">
                    By signing in, you agree to our
                    <a href="https://site.vuemix.com/terms.html" target="_blank">Terms of Service</a> &amp;
                    <a href="https://site.vuemix.com/privacy.html" target="_blank">Privacy Policy</a>
                  </b-form-text>
                  <div class="text-center" style="font-size:0.7rem;"
                    v-if="version">
                    {{version}}
                  </div>
                </b-form-group>
              </b-form>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-alert show fade class="position-fixed" variant="warning" v-model="$parent.show_msg_tracking">
      You have allowed tracking. However, the only cookies we use are those necessary for authentication and security.
      <b-button-group class="float-right">
         <b-button size="sm" variant="warning" @click="$parent.dismissTrackMessage()"> Okay </b-button>
      </b-button-group>
    </b-alert>
    <b-alert show fade class="position-fixed" variant="warning" v-model="$parent.show_msg_no_tracking">
      <span style="textDecoration:underline"> We never track you </span>. The only cookies we use are those necessary for authentication and security.
      <b-button-group class="float-right">
         <b-button size="sm" variant="warning" @click="$parent.dismissTrackMessage()"> Dismiss </b-button>
      </b-button-group>
    </b-alert>
  </div>
</template>

<script>
import vx_api from "../vuemix";
import store from "../store";

export default {
  name: "login",
  components: {},
  computed: {},
  created() {
    let host = window.location.host;
    let vue = this;
    if (host.indexOf("devdev.staging.vuemix.com") >= 0) {
       vue.srcName = "(Dev)";
       vue.src = "dev";
    } else if (host.indexOf("staging.vuemix.com") >= 0) {
       vue.srcName = "(Staging)";
       vue.src = "staging";
    }

    let provider = vue.$router.currentRoute.params.provider || "";
    switch (provider) {
    case "google": vue.ggSignIn(); return;
    case "outlook": vue.outlookSignIn(); return;
    case "apple": vue.appleSignIn(); return;
    }

    vue.initUserAccount();
    vue.inq_tid = setInterval(vue.userAccountKeyin, 150);
    window.close_all_opened();
    vxslog({p:"login",a:"open"});
  },
  mounted() {
    let vue = this;
    vue.version = vx && vx.about && vx.about.site_version;
  },
  beforeDestroy() {
    if (this.wss) {
      this.wss.close();
      delete this.wss;
    }
    if (this.inq_tid) {
       clearInterval(this.inq_tid);
       delete this.inq_tid;
    }
  },
  data() {
    return {
      userForm: {
        email: this.$cookies.get("email") || "",
        password: "",
        wss: null,
      },
      userAccount: {state:true,
                    q:"",
                    showapl: false,
                    showoutl: false,
                    showfb: false,
                    showgg: false,
                    showsaml: false,
                    showvx: false,
                    showreg: false,
                    go: false,
                    logo: "",
                    past: [],
                    pastlist: []},
      srcName: "",
      src: "prod",
      version: "",
      showbah: false,
    };
  },
  methods: {
    accountAPI: function(q, cb) {
      let vue = this;
      if (!q || q.length < 3) { return; }
      let url = vx.rq_endpoint+"/adm/account/kp/"+q+"/cfg";
      issue_http({nocred:true, type:"GET", url: url, done: function(s,r) {
         if (s == 200) {
           vue.userAccount.state = true;
           let j = to_json(r);
           cb(j);
         } else {
           vue.userAccount.state = false;
         }
      }});
    },
    initUserAccount: function() {
      let vue = this;
      let subd = window.vx.subd;
      if (window.location.host.indexOf("devdev") >= 0) {
         /* Override ONLY init for dev page */
         subd = "dev";
      }
      vue.accountAPI(subd, function(wr) {
        // eslint-disable-next-line 
        if (vx && vx.debug) { console.log("init:"+JSON.stringify(wr)); }
        vue.userAccount.pq = wr.q;
        vue.userAccount.q = wr.q;
        vue.userAccount.in_q = wr.q;
        vue.userAccount.showfb = wr.fb;
        vue.userAccount.showapl = wr.apl;
        vue.userAccount.showoutl = wr.outl;
        vue.userAccount.showgg = wr.gg;
        vue.userAccount.showsaml = wr.saml;
        vue.userAccount.showvx = wr.vxs;
        vue.userAccount.showreg = (wr.vxs && wr.reg);
        vue.userAccount.tgt = wr.tgt;
        vue.userAccount.logo = wr.logo;
        vue.showbah = wr.showbah || false;
        if (wr.dfr) {
           setLocal("vx_def_room",wr.dfr);
        } else {
           eraseLocal("vx_def_room");
        }
        let past = JSON.parse(window.getLocal("vxaccount_past") || "[]");
        vue.userAccount.past = past;
        window.setLocal("vxaccount_past", JSON.stringify(past), "90d");
        let arr = [];
        past.forEach(function(p) {
          if (arr.length > 4) { return; }
          let d = p.split("-app")[0];
          let v = "outline-success";
          if (p.indexOf("staging") >= 0) {
            v = "outline-secondary";
          }
          arr.push({name:d, dom:p, var:v});
        });
        vue.userAccount.pastlist = arr;
      });
    },
    selectPast: function(p) {
      let vue = this;
      vue.accountAPI(p, function(wr) {
         let url = wr.tgt + "#/login";
         //console.log(url);
         window.location.href = url;
      });
    },
    userAccountKeyin: function() {
      let vue = this;
      if (!vue.userAccount || !vue.userAccount.q) { return; }
      vue.userAccount.q = vue.userAccount.q.toLowerCase();
      if (vue.userAccount.q == vue.userAccount.in_q) {
        return;
      }
      vue.userAccount.in_q = vue.userAccount.q;
      if (vue.userAccount.tid) {
        window.clearTimeout(vue.userAccount.tid);
        delete vue.userAccount.tid;
      }
      vue.userAccount.tid = window.setTimeout(function() {
        vue.userAccount.go = false;
        delete vue.userAccount.wr;
        if (vue.userAccount.q != vue.userAccount.pq) {
          if (vue.userAccount.tid_kill) {
            window.clearTimeout(vue.userAccount.tid_kill);
            delete vue.userAccount.tid_kill;
          }
          vue.userAccount.tid_kill = window.setTimeout(function() {
            // eslint-disable-next-line 
            console.log("kill account update");
            vue.userAccount.state = true;
            vue.userAccount.q = vue.userAccount.pq;
            delete vue.userAccount.tid_kill;
          }, 4000);
          vue.accountAPI(vue.userAccount.q, function(wr) {
             if (vue.userAccount.tid_kill) {
               /* Because of aliases, the queried account
                  may still be the same */
               if (wr.q != vue.userAccount.pq) {
                 vue.userAccount.wr = wr;
                 vue.userAccount.go = true;
                 vue.goAccount();
                 window.clearTimeout(vue.userAccount.tid_kill);
                 delete vue.userAccount.tid_kill;
               }
             }
          });
        } else {
          vue.userAccount.state = true;
        }
      }, 500);
      
    },
    showAppLaunch() {
      let vue = this;
      if (vue.$parent.mydevice.is_app || vue.$parent.mydevice.is_pwa) {
        return false;
      }
      return true;
    },
    doAppLaunch() {
      let vue = this;
      //let url = "vxstreamer://"+vue.$router.currentRoute.path;
      //window.open(url, '_blank');
      vue.$router.push({name: "download"});
    },
    doBAH() {
      let vue = this;
      vue.$router.push({name: "hosting"});
    },
    goPReset() {
      this.$router.push({name: 'preset'});
    },
    goGuest() {
      vxslog({p:"login",a:"guest"});
      this.$router.push({name: 'guest'});
    },
    openLoginWSS() {
      let vue = this;
      let uuid = window.vx.about.app_uuid;
      let msg = JSON.stringify({action:"setuuid",uuid:uuid});
      if (vue.wss) {
         vue.wss.send(msg);
         return;
      }
      vue.wss = new WebSocket(vx.wss_endpoint);
      vue.wss.onopen = function() {
         vue.wss.send(msg);
      }
      vue.wss.onmessage = function(ev) {
         let j = to_json(ev.data);
         let tk = to_json(j.tk);
         let cred = tk.creds.me+"&guid="+tk.id;
         vx_api.getSelf(window.vx,cred).then(self_res => {
           vue.$user.set(Object.assign({
              role: "authenticatedUser"
           },
           self_res));
           continue_to_page(vue.$router);
         }).catch(e => {
           console.log("error",e);
         });
      }
      vue.wss.onclose = function(ev) {
         vue.wss = null;
      }
    },
    initiateAuth(LoginURL,resume) {
      let vue = this;
      if (vue.$parent.mydevice.in_cors_iframe) {
          vue.openLoginWSS();
          LoginURL += "&uuid="+window.vx.about.app_uuid;
          if (vx && vx.debug) { console.log("Ext OAuth",LoginURL); }
          window.open(LoginURL, "extlogin", "popup");
      } else {
        LoginURL += "&resume="+encodeURIComponent(resume);
        window.location.href = LoginURL;
      }
    },
    goAccount() {
      let vue = this;
      let past = JSON.parse(window.getLocal("vxaccount_past") || "[]");
      //console.log(JSON.stringify(past));
      if (past.indexOf(vue.userAccount.wr.q) < 0) {
        past.push(vue.userAccount.wr.q);
      }
      window.setLocal("vxaccount_past", JSON.stringify(past), "90d");
      let url = vue.userAccount.wr.tgt + "#/login";
      window.location.href = url;
    },
    submitForm: function() {
      let vue = this;
      let opt;
      vxslog({p:"login",a:"vxsign"});
      vue.$cookies.set("email", this.userForm.email, "90d");
      if (vue.$parent.mydevice.in_cors_iframe) {
        opt = { nocookie: true };
      }
      vx_api
        .signIn(window.vx, vue.userForm, opt)
        .then(data => {
          let cred;
          if (data.cred && data.id) {
            cred = data.cred+"&guid="+data.id;
          }
          vx_api.getSelf(window.vx,cred).then(self_res => {
            self_res.loggedInFrom = "vuemix";
            vue.$user.set(
              Object.assign(
                {
                  role: "authenticatedUser"
                },
                self_res
              )
            );
            window.wss_login_open(window.vx);
            // eslint-disable-next-line 
            console.log("SIGNED IN");
            if (vue.userAccount.tgt && window.vx.about && window.vx.about.start_url &&
                vue.userAccount.tgt != window.vx.about.start_url) {
              // eslint-disable-next-line 
              console.log("Change start url to:"+vue.userAccount.tgt);
              vue.$parent.mydevice.set_defaults({cfg:{"START_URL":vue.userAccount.tgt}});
            }
            /* 3rdparty does not need this (handled by post_login_url)
             * because they leave and return. This is needed for direct
             * signin because you can signout and signin without
             * reloading */
            if (!getLocal("vx_page_href")) {
              setLocal("vx_page_href","_default");
            }
            continue_to_page(vue.$router);
          });
        })
        .catch(e => {
          vue.$parent.signUserOut(e, "Login Failed", "danger");
        });
    },
    ggSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let resume = window.location.pathname;
      let base = "https://mapp.vuemix.com";
      vxslog({p:"login",a:"ggsign"});
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
         base +
         "/mm/loginredirect.html?action=google_auth&acc=" +
         host;
      vue.initiateAuth(LoginURL, resume+"#/login");
    },
    fbSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let resume = window.location.pathname;
      let base = "https://mapp.vuemix.com";      
      vxslog({p:"login",a:"fbsign"});
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
        base +
        "/mm/loginredirect.html?action=facebook_auth&acc=" +
        host;
      vue.initiateAuth(LoginURL, resume+"#/login");
    },
    samlSignIn: function() {
      let host = window.location.host;
      let resume = window.location.pathname;
      let base = "https://app.vuemix.com";
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      ////
      base = "https://uploadvue-app.staging.vuemix.com"
      ////
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
        base +
        "/mm/loginredirect.html?action=saml_auth&acc=" +
        host +
        "&resume=" +
        encodeURIComponent(resume + "#/loggedinfrom/saml");
      window.location.href = LoginURL;
    },
    appleSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let resume = window.location.pathname;
      let base = "https://mapp.vuemix.com";
      vxslog({p:"login",a:"apsign"});
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
        base +
        "/mm/loginredirect.html?action=apple_auth&acc=" +
        host;
      vue.initiateAuth(LoginURL, resume+"#/loggedinfrom/apple");
    },
    outlookSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let resume = window.location.pathname;
      let base = "https://mapp.vuemix.com";
      vxslog({p:"login",a:"mssign"});
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
        base +
        "/mm/loginredirect.html?action=outlook_auth&acc=" +
        host;
      vue.initiateAuth(LoginURL, resume+"#/loggedinfrom/outlook");
    },
  }
};
</script>

<style lang="scss" scoped>
.tcon {
  display:flex;
  justify-content: space-around;
  margin: 0 10%;
}
.tpart {
  flex: 0 1 64px;
}

.form-control.is-valid:focus {
  border-color:#909090;
}
.form-control.is-valid {
  border-color:#909090;
}
</style>
